import React from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css';

export default function NavBar() {
  return (
    <nav className="navbar" aria-label="Main navigation">
      <NavLink to="/" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'} aria-label="Home">
        <span role="img" aria-label="Timer">⏰</span>
        <span className="nav-label">Focus</span>
      </NavLink>
      <NavLink to="/analytics" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'} aria-label="Analytics">
        <span role="img" aria-label="Analytics">📊</span>
        <span className="nav-label">Analytics</span>
      </NavLink>
      <NavLink to="/gamification" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'} aria-label="Gamification">
        <span role="img" aria-label="Gamification">🎮</span>
        <span className="nav-label">Gamification</span>
      </NavLink>
    </nav>
  );
}